import COMMON_TYPES from '../../../actions/types';
import * as analytics from '../../../analytics';
import { showNotificationLayer } from '../../../actions/notification';
import { createObject, deleteObject } from '../../../api/object';
import { saveArchiveService, deleteArchiveService } from '../../../api/service';
import { formatDataArchive } from '../utils';
import { details } from '../../../api/common';

const loadingPost = () => ({ type: COMMON_TYPES.formPostWatingResponse });

export const deleteFile = ({ formParams }) => {
  const { id, treatmentId, key } = formParams;

  return async dispatch => {
    try {
      await Promise.all([
        deleteArchiveService({ id, treatmentId }),
        deleteObject({ key })
      ]);
    }
    catch (responseFail) {
      return dispatch({
        type: COMMON_TYPES.formPostResultError,
        payload: responseFail.response.data,
      });
    }
  }
}

export const uploadFile = ({ formParams }) => {
  return dispatch => {
    dispatch(loadingPost());

    createObject(formParams.fileStream)
      .then(response => {
        const { id } = formParams;
        const { name, url } = response.data;

        saveArchiveService({
          id,
          name,
          url,
        })
          .then(() => {
            dispatch(toggleFormCreateArchiveLayer());

            dispatch(
              showNotificationLayer('O arquivo foi salvo no atendimento!')
            );
          })
          .catch(responseFail => {
            dispatch(loadingPost());
            dispatch({
              type: COMMON_TYPES.formPostResultError,
              payload: responseFail.response
            });
          });
      })
      .catch(responseFail => {
        dispatch(loadingPost());
        dispatch({
          type: COMMON_TYPES.formPostResultError,
          payload: responseFail.response.data
        });
      });
  };
}

export const toggleFormCreateArchiveLayer = params => {
  if(params && params.id) {
    analytics.registerEvent({
      category: analytics.categories.service,
      action: analytics.actions.serviceArchive,
    });

    return dispatch => {
      dispatch([
        {
          type: COMMON_TYPES.toggleLayer,
          payload: 'createArchive',
        },
        { type: COMMON_TYPES.formGetWatingResponse, payload: true },
      ]);

      details({ id: params.id, path: 'atendimento.php' })
        .then(({ data }) => {
          dispatch([{
              type: COMMON_TYPES.formInitializeValues,
              payload: formatDataArchive(data),
            },
            { type: COMMON_TYPES.formGetWatingResponse, payload: false },
          ])
        })
        .catch((e) =>
          dispatch({ type: COMMON_TYPES.formGetResultError })
        )
    }
  }

  return [
    { type: COMMON_TYPES.toggleLayer, payload: null },
    { type: COMMON_TYPES.formClearValues },
  ];
};
